import { BlueprintInstanceType } from '../shared.enums';
import { Countertops } from '../countertops/countertops.class';
import { Dimensions } from '../dimensions/dimensions.class';
import { Islands } from '../islands/islands.class';
import { Kitchen } from '../kitchens/kitchen.class';
import { kitchenDesignData } from './kitchen-design.data';
import { Notifications } from '../notifications/notifications.class';

import { KitchenDesignBase, KitchenDesignOptions } from '../kitchen-design-base';
import { KitchenDesignDataIn, KitchenDesignDataOut } from './types';
import { Obstructions } from '../obstructions/obstructions.class';

export class KitchenDesign extends KitchenDesignBase<KitchenDesignDataIn> {
	#defaultIslandId: string;

	readonly dimensions: Dimensions;
	readonly islands: Islands;
	readonly countertops: Countertops;
	readonly obstructions: Obstructions;
	readonly notifications: Notifications;

	constructor (kitchen: Kitchen, options: KitchenDesignOptions<KitchenDesignDataIn> = {}) {
		super(BlueprintInstanceType.KitchenDesign, options);

		const data = kitchenDesignData(this.context, options.dataIn);

		this.dimensions = new Dimensions({ dataIn: data.dimensions, parent: this });
		this.islands = new Islands({ dataIn: data.islands, parent: this });
		this.countertops = new Countertops({ dataIn: data.countertops, parent: this });
		this.obstructions = new Obstructions({ dataIn: data.obstructions, parent: this });
		this.notifications = new Notifications({ dataIn: data.notifications, parent: this });

		this.setInitialized();
	}

	get defaultIslandId (): string { return this.#defaultIslandId }

	public serialize (): KitchenDesignDataOut {
		return {
			islands: this.islands.serialize(),
			countertops: this.countertops.serialize(),
			dimensions: this.dimensions.serialize(),
			obstructions: this.obstructions.serialize(),
			notifications: this.notifications.serialize()
		};
	}
}
